import gql from 'graphql-tag';

export default gql`
  fragment BundleOrderItemFragment on OrderItem {
    ... on BundleOrderItem {
      id
      flightId
      bundle {
        id
        tier
        name
        banner
        ancillaries {
          code
          name
          type
          icon
          price {
            amount
          }
        }
      }
      price {
        amount
        currency
      }
    }
  }
`;
